/**
 * Debounces an action for a given period of time (ms)
 */ export class ActionDebouncer {
    /** Start a new debounce timer. If there is an ongoing timer, cancel it and start a new one in it's place */ startOrRefreshDebounce() {
        this.cancelPendingDebounce();
        // Starts a tracked timeout to call handler onDebouncePeriodEnd
        this.debounceTimeoutTracker = window.setTimeout(()=>{
            this.onDebouncePeriodEnd();
            this.debounceTimeoutTracker = undefined;
        }, this.debouncePeriodMs);
    }
    /** Perform a partial clean up of debouncer. Debouncer is considered reusable after cancelPendingDebounce() */ cancelPendingDebounce() {
        if (this.debounceTimeoutTracker !== undefined) {
            window.clearTimeout(this.debounceTimeoutTracker);
            this.debounceTimeoutTracker = undefined;
        }
    }
    /** Perform a full clean up of debouncer. Debouncer is considered destroyed and non-usable after dispose() */ dispose() {
        this.cancelPendingDebounce();
    }
    /**
   * @param onDebouncePeriodEnd - Handler to invoke only after debounce period has elapsed without change in state
   * @param debouncePeriodMs - How long we should wait before calling onDebouncePeriodEnd callback
   */ constructor(onDebouncePeriodEnd, debouncePeriodMs){
        this.onDebouncePeriodEnd = onDebouncePeriodEnd;
        this.debouncePeriodMs = debouncePeriodMs;
    }
} // cspell:ignore Debouncer Debounces
